import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";
import {
  getPurchaseReturn,
  getPurchaseReturnById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  getPurchaseInvoiceDetail,
  createPurchaseReturn,
  getPurchaseReturnAdditionalChargeList,
} from "./thunk";

const initialState = {
  purchaseReturns: [],
  edit: false,
  purchaseReturn: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingPurchaseReturn: false,
  loadingNext: false,
  loadingDetails: false,
  purchaseInvoice: null,
  purchaseInvoiceDetails: [
    {
      unique: uuidv4(),
      product: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate().toADasDate()),
    },
  ],
  additionalCharges: [],
  saveAndContinue: false,
  showCreateModal: false,

  selectedPurchaseInvoiceDetails: [],

  formData: {
    purchaseOrderInvoice: null,
    branch: null,
    orderNo: "",
    partyAccount: null,
    // refundAmount: "",
    grandTotal: "",
    remarks: "",
    documentsAttach: [],
    voucherDateBs: new NepaliDate().format("YYYY-MM-DD"),

    purchaseReturnMainPartyDetails: {
      jobNumber: "",
    },
    purchaseReturnMainVehicleDetail: {
      vehicleNo: "",
      builtyNo: "",
      driverName: "",
      driverPhoneNo: "",
      driverAddress: "",
      licenseNo: "",
      transporter: "",
      quantity: "",
    },
  },
};

export const purchaseReturnSlice = createSlice({
  name: "purchaseReturn",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },

    setSelectedInvoiceDetails: (state, action) => {
      state.selectedPurchaseInvoiceDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },
    setPurchaseInvoice: (state, action) => {
      state.purchaseinvoice = action.payload;
    },
    purchaseInvoiceDetailsUpdated: (state, action) => {
      state.purchaseInvoiceDetails = action.payload;
    },
    updatedAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    setPurchaseInvoiceDetails: (state, action) => {
      state.purchaseInvoiceDetails = [
        ...action.payload.map((value) => ({
          ...value,
          description: value.product?.name || "",
          actualQuantity: value.actualQuantity - value.returnQuantity,
          validateQuantity: value.actualQuantity - value.returnQuantity,
          amount: value.rate * (value.actualQuantity - value.returnQuantity),
        })),
        {
          unique: uuidv4(),
          product: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
        },
      ];
    },

    clearSelectedOrderData: (state) => {
      state.selectedPurchaseInvoiceDetails = [];
    },
    clearPurchaseInvoiceDetails: (state) => {
      state.purchaseInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
        },
      ];
    },
    clearAllPurchaseReturn: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPurchaseReturn = false;
      state.purchaseReturn = null;
      state.purchaseInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
        },
      ];
      state.additionalCharges = [];
      state.saveAndContinue = false;
      state.selectedPurchaseInvoiceDetails = [];
      state.formData = initialState.formData;
    },

    savePurchaseReturnForm: (state, action) => {
      state.formData = action.payload;
    },
    resetPurchaseReturnForm: (state, action) => {
      if (action.payload) {
        state.formData = state.purchaseOrder;
      } else {
        state.formData = initialState.formData;
        state.selectedPurchaseInvoiceDetails = initialState.selectedPurchaseInvoiceDetails;

        state.purchaseReturn = initialState.purchaseReturn;
        state.purchaseInvoiceDetails = initialState.purchaseInvoiceDetails;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPurchaseReturnAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getPurchaseReturnAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data;
    });
    builder.addCase(getPurchaseReturnAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });
    // invoice details
    builder.addCase(createPurchaseReturn.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createPurchaseReturn.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createPurchaseReturn.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getPurchaseInvoiceDetail.pending, (state) => {
      state.loadingDetails = true;
      // state.purchaseInvoiceDetails = null;
    });
    builder.addCase(getPurchaseInvoiceDetail.fulfilled, (state, action) => {
      state.loadingDetails = false;
      // state.purchaseInvoiceDetails = action.payload.data.purchaseInvoiceDetail;
    });
    builder.addCase(getPurchaseInvoiceDetail.rejected, (state) => {
      state.loadingDetails = false;
      // state.purchaseInvoiceDetails = null;
    });
    // getPurchaseReturnById
    builder.addCase(getPurchaseReturnById.pending, (state) => {
      state.loading = true;
      state.purchaseReturn = null;
    });
    builder.addCase(getPurchaseReturnById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.purchaseReturn = action.payload.data;
      state.purchaseInvoiceDetails = action.payload.data?.purchaseOrderReturnDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getPurchaseReturnById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.purchaseReturn = null;
    });
    builder.addMatcher(
      isAnyOf(
        getPurchaseReturn.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingPurchaseReturn = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getPurchaseReturn.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPurchaseReturn = false;
        state.purchaseReturns = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPurchaseReturn.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPurchaseReturn = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,

  setPurchaseInvoice,
  setSelectedInvoiceDetails,
  purchaseInvoiceDetailsUpdated,
  updatedAdditionalCharges,
  setPurchaseInvoiceDetails,
  clearSelectedOrderData,
  clearPurchaseInvoiceDetails,
  clearAllPurchaseReturn,
  savePurchaseReturnForm,
  resetPurchaseReturnForm,
} = purchaseReturnSlice.actions;

export default purchaseReturnSlice.reducer;
